export default __webpack_public_path__ + "static/media/Francesco Di Giacolo e Rodolfo Maltese.19f0e1c7.jpg";